import { ActionType, createAction } from 'typesafe-actions'

import { SearchCompany } from './types'

export const SearchActions = {
  loadSearchData: createAction('SEARCH/load-data')<{
    filter: string
    query: string
    countryFilter?: string
    page: number
    pageSize: number
    preferredProduct: string | undefined
  }>(),
  setLoadedCompanies: createAction('SEARCH/set-companies')<{
    companies: SearchCompany[]
    totalCount: number
    pageCount: number
    pageSize: number
  }>()
}

export type SearchActions = ActionType<typeof SearchActions>
